import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, UserCheck, Lock } from "lucide-react";
import heroBg from "@/assets/hero-bg.jpg";
import elaraLogo from "@/assets/elara-logo.png";

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="" className="w-full h-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-background/50" />
      </div>

      {/* Large faded logo watermark */}
      <div className="absolute right-[-5%] top-1/2 -translate-y-1/2 pointer-events-none select-none">
        <img
          src={elaraLogo}
          alt=""
          className="w-[500px] md:w-[650px] lg:w-[800px] h-auto opacity-[0.06]"
        />
      </div>

      <div className="container relative z-10 mx-auto px-4 pt-28 pb-16">
        <div className="max-w-2xl space-y-6">
          <p className="text-sm font-semibold uppercase tracking-widest text-champagne animate-fade-up">
            Precision Care for Lasting Transformation
          </p>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-foreground animate-fade-up" style={{ animationDelay: "0.1s" }}>
            Physician-Guided Care for Early Risk Identification & Personalized Optimization
          </h1>
          <p className="text-lg text-muted-foreground max-w-xl animate-fade-up" style={{ animationDelay: "0.2s" }}>
            Evidence-based, personalized care coordinated through independently licensed physicians — focused on identifying risk early and supporting long-term metabolic health.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 animate-fade-up" style={{ animationDelay: "0.3s" }}>
            <Link to="/get-started">
              <Button size="lg" className="gap-2 text-base">
                Start Your 2-Minute Assessment <ArrowRight size={18} />
              </Button>
            </Link>
            <a href="#how-it-works">
              <Button variant="outline" size="lg" className="text-base">
                How It Works
              </Button>
            </a>
          </div>
          {/* CTA disclaimer (PRD v3.0) */}
          <p className="text-[11px] text-muted-foreground/80 max-w-md leading-relaxed animate-fade-up" style={{ animationDelay: "0.32s" }}>
            By continuing, you acknowledge medical services are provided by independently licensed physicians and may not be available in all states.
          </p>
          {/* Microcopy */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground animate-fade-up" style={{ animationDelay: "0.35s" }}>
            <span>Takes less than 2 minutes</span>
            <span className="before:content-['•'] before:mr-4">No commitment required</span>
            <span className="before:content-['•'] before:mr-4">Reviewed by board-certified physicians</span>
          </div>
          {/* Trust bar */}
          <div className="flex flex-wrap items-center gap-6 pt-2 text-sm text-muted-foreground animate-fade-up" style={{ animationDelay: "0.4s" }}>
            <span className="flex items-center gap-1.5">
              <UserCheck size={16} className="text-champagne" /> Board-Certified U.S. Physicians
            </span>
            <span className="flex items-center gap-1.5">
              <ShieldCheck size={16} className="text-champagne" /> Limited New Patient Slots
            </span>
            <span className="flex items-center gap-1.5">
              <Lock size={16} className="text-champagne" /> HIPAA-Compliant & Confidential
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
